var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.loading
    ? _c("Loading")
    : _c("Box", { staticClass: "responder", attrs: { padding: 5 } }, [
        _vm.error
          ? _c("div", { staticClass: "error" }, [
              _vm._v("Error executing request")
            ])
          : _vm._e(),
        !_vm.error && _vm.tokenData
          ? _c("div", { staticClass: "success" }, [
              _vm._v(
                " Pledge " +
                  _vm._s(_vm.tokenData.pledgeId) +
                  " have been set as "
              ),
              _c("span", { staticClass: "approve" }, [_vm._v("Accounting")])
            ])
          : _vm._e()
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }